import { Routes, Route } from 'react-router-dom';

import Header from './views/partials/Header';
import Footer from './views/partials/Footer';
import Home from './views/Home/Index';
import LeaderDetail from './views/Team/Detail';
import Contact from './views/Contact/Index';
import NotFound from './views/NotFound';
import useSeo from './seo/useSeo';
import ScrollToHash from './views/partials/ScrollToHash';
import './App.css';

function App() {
    useSeo();

    return (
        <div className="App">
            <ScrollToHash />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/team/:slug" element={<LeaderDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;
